import { gql } from '@apollo/client'

export const Query = gql`
  query EditWarehouse($companyId: ID!, $filters: WarehouseFilters) {
    warehouses(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        address1
        address2
        address3
        city
        county
        postcode
        address
      }
    }
  }
`
